import { LeatFrontendService } from "../modules/leat";
export const leatService = new LeatFrontendService();
